<template>
  <div id="menu-burger">
    <v-row no-gutters>
      <v-col class="d-flex justify-end">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-navigation-drawer v-model="drawer" absolute temporary width="100%">
          <div class="d-flex justify-end align-center pa-5">
            <v-btn
              class="ma-2"
              text
              icon
              color="red lighten-2"
              @click="drawer = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-list nav dense>
            <v-list-item-group
              v-model="group"
              active-class="deep-purple--text text--accent-4"
            >
              <v-list-item>
                <v-list-item-title
                  ><a class="menu-button-burger" href="https://temanbakat.id"
                    >BERANDA</a
                  ></v-list-item-title
                >
              </v-list-item>

              <v-list-item>
                <v-list-item-title
                  ><a
                    class="menu-button-burger"
                    href="https://temanbakat.id/penjurusan"
                    >CARI JURUSAN</a
                  ></v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list>

          <div class="d-flex justify-center align-center mt-5">
            <v-img
              contain
              lazy-src="../../assets/img/logo-teman-bakat.png"
              max-height="50"
              max-width="50"
              src="../../assets/img/logo-teman-bakat.png"
            ></v-img>
          </div>
        </v-navigation-drawer>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Menu",
  data: () => ({
    drawer: false,
    group: null,
  }),
  watch: {
    group() {
      this.drawer = false;
    },
  },
};
</script>

<style>
#menu-burger {
  background-color: none !important;
}
.menu-button-burger {
  color: black !important;
  text-decoration: none !important;
}
</style>
